<template>
  <div :class="$style.wrapper">
    <VTDropdownPill
      secondary-button-label="Cancel"
      :is-enabled="isEditable"
      :should-close="closeDropdown"
      :close-on-save="false"
      :disable-save-button="cantSave"
      @confirm="handleConfirm"
      @clear="handleCancel"
      @on-click-outside="handleCancel"
      @click="handlePropagation"
    >
      <template #dropDownHeader>
        <div :class="[$style.triggerSection, isEditable ? $style.hoverEffect : '']">
          <div>
            <p :class="$style.name">{{ name }}</p>
            <p :class="$style.technicalName">{{ technicalName }}</p>
          </div>
          <VdIcon v-if="isEditable" store="fas" name="pen-to-square" size="medium" color="#909298" />
        </div>
      </template>
      <template #dropdown-content>
        <div>
          <InputText v-model="localName" placeholder="Edit Name" :class="$style.nameInput" />
        </div>
      </template>
    </VTDropdownPill>
  </div>
</template>

<script setup>
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import VTDropdownPill from "@/components/VTDropdownPill";
import InputText from "primevue/inputtext";
import { computed, ref } from "vue";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  technicalName: {
    type: String,
    required: true,
  },
  isEditable: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:name"]);
const localName = ref(props.name);

const closeDropdown = ref(false);

const cantSave = computed(() => localName.value === props.name);

const handleConfirm = () => {
  const trimmedName = localName.value.trim();
  emit("update:name", trimmedName);
  closeDropdown.value = true;
  localName.value = props.name;
};

const handleCancel = () => {
  localName.value = props.name;
};

function handlePropagation(event) {
  event.stopPropagation();
}
</script>

<style module>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.name {
  font-size: 16px;
  margin: 0;
  text-align: left;
}

.technicalName {
  font-size: 12px;
  color: var(--vd-color-text-light-2);
  margin: 0;
  text-align: left;
}

.triggerSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.error {
  color: red;
  margin-bottom: 0.5rem;
  font-size: 12px;
}

.nameInput {
  margin-bottom: 0.5rem;
}

.hoverEffect {
  transition: all 0.3s;
  border-radius: 50px;
  padding: 0px 10px;
}

.hoverEffect:hover {
  background-color: var(--vd-color-surface-100);
  padding: 0px 15px;
}
</style>

<style scoped>
:deep(.p-inputtext) {
  width: 100%;
}
</style>
